import { render, staticRenderFns } from "./ComboDetailIntro.vue?vue&type=template&id=5944f96c&scoped=true&"
import script from "./ComboDetailIntro.vue?vue&type=script&lang=js&"
export * from "./ComboDetailIntro.vue?vue&type=script&lang=js&"
import style0 from "./ComboDetailIntro.vue?vue&type=style&index=0&id=5944f96c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5944f96c",
  null
  
)

export default component.exports